var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-app container",attrs:{"id":"app"}},[_c('f-loader',{attrs:{"show":true,"text":"Applikationen laddas..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }